import { IChunkAttachment } from "@/interfaces/IChunkAttachment";

export class ContractAttachment implements IChunkAttachment {
    public id: string;
    public fileName: string;
    public sessionId: string;
    public processId: string;
    public status: string;
    public toDelete: boolean;
    public uploadContractStep: number;

    constructor(
        id?: string,
        fileName?: string,
        sessionId?: string,
        processId?: string,
        status?: string,
        toDelete?: boolean,
        uploadContractStep?: number
      ) {
        this.id = id;
        this.fileName = fileName;
        this.sessionId = sessionId;
        this.processId = processId;
        this.status = status;
        this.toDelete = toDelete;
        this.uploadContractStep = uploadContractStep;
      }
}